/*

    Třída Ids
    Slouží pro systematické číslovaní v řadě s využitím mezer po odpojených hráčů.

*/
class Ids {
    #ids = [];
    #maxid = 10000;

    constructor(size = 10000) {
        this.#maxid = size;
    }

    getFreeId() {
        for (let i = 1; i < this.#maxid; i++) {
            if (!this.#ids.includes(i)) {
                this.#ids[i] = i;
                return i;
            }
        }
    }

    removeId(index) {
        this.#ids.splice(index, 1);
    }
}

export { Ids };
